module.exports = __webpack_public_path__ + "static/solution-healthcareeducation@2x-af9f6b6ef7ba5d69a484040bf931f71b.png";